"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const input_1 = require("./input");
const util_1 = require("./util");
exports.accountStatus = util_1.enumOf("NotVerified", "Verified");
exports.userType = util_1.enumOf("Client", "Lawyer");
exports.jwtObject = yup.object({
    accountStatus: exports.accountStatus,
    createdAt: input_1.dateInput,
    id: input_1.id,
    phoneNumber: input_1.phoneNumber,
    userType: exports.userType,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiand0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2p3dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSx5Q0FBMEI7QUFDMUIsbUNBQWtEO0FBQ2xELGlDQUE2QjtBQUtoQixRQUFBLGFBQWEsR0FBRyxhQUFNLENBQWdCLGFBQWEsRUFBRSxVQUFVLENBQUMsQ0FBQTtBQUVoRSxRQUFBLFFBQVEsR0FBRyxhQUFNLENBQVcsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFBO0FBRS9DLFFBQUEsU0FBUyxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUM7SUFDaEMsYUFBYSxFQUFiLHFCQUFhO0lBQ2IsU0FBUyxFQUFFLGlCQUFTO0lBQ3BCLEVBQUUsRUFBRixVQUFFO0lBQ0YsV0FBVyxFQUFYLG1CQUFXO0lBQ1gsUUFBUSxFQUFSLGdCQUFRO0NBQ1gsQ0FBQyxDQUFBIn0=